export default __webpack_public_path__ + "static/media/party-perfect.5308485b.png";